export function pluckUndefined<T>(o: T): T {
  if (!o) {
    return;
  }
  const keys = Array.from(Object.keys(o));
  keys.forEach((key) => {
    if (typeof o[key] === 'undefined') {
      delete o[key];
    }
  });
  return o;
}
